<template>
  <modal v-model="openModel" :max-width="550">
    <template #title>Stop Screening</template>
    <template #content>
      <p>
        The stopping criteria has not been met yet, indicating that it
        is likely there are more relevant documents remaining.
      </p>
      <p>
        Are you sure you want to mark the remaining documents as
        <span class="font-weight-bold">Not Relevant</span>?
      </p>
    </template>
    <template #actions>
      <action-button @click="openModel = false">
        Cancel
      </action-button>
      <action-button
        class="ml-3"
        color="error"
        @click="$emit('exclude-remaining')"
      >
        Exclude Remaining
      </action-button>
    </template>
  </modal>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import Modal from '@/components/Common/Modal';

export default {
  name: 'StopScreeningPrematureModal',
  components: {
    ActionButton,
    Modal,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    allowExcludeRemaining: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:open', 'exclude-remaining'],
  computed: {
    openModel: {
      get: function () {
        return this.open;
      },
      set: function (value) {
        this.$emit('update:open', value);
      },
    },
  },
};
</script>
